module.exports = __webpack_public_path__ + "img/tarj1-3.b0b51d05.svg";